<template>
  <section class="busqueda-de-producto">
    <!-- Móvil: input grande + lista táctil de resultados -->
    <div v-if="esMovil">
      <b-field label="Nombre o código del producto">
        <b-input
          v-model="producto"
          id="producto"
          size="is-large"
          icon="magnify"
          icon-right="barcode-scan"
          placeholder="Escribe el nombre o el código de barras del producto"
          @input="buscarProductos"
          expanded
        />
      </b-field>

      <div class="lista-resultados-movil" v-if="productosEncontrados.length">
        <button
          type="button"
          class="fila-producto"
          v-for="opcion in productosEncontrados"
          :key="opcion.id"
          @click="seleccionarProducto(opcion)"
        >
          <div class="fila-info">
            <span class="fila-nombre">{{ opcion.nombre }}</span>
            <span class="fila-detalle">
              <span v-if="opcion.codigo">Código: {{ opcion.codigo }}</span>
              <span v-if="opcion.existencia !== undefined"> · Stock: {{ formatoMonto(opcion.existencia) }}</span>
            </span>
          </div>
          <div class="fila-precio">
            <span v-if="opcion.precioVenta !== undefined">${{ formatoMonto(opcion.precioVenta) }}</span>
            <b-icon icon="chevron-right" size="is-medium"></b-icon>
          </div>
        </button>
      </div>
      <p class="has-text-centered is-size-7 has-text-grey py-2" v-else-if="buscando">
        Buscando…
      </p>
    </div>

    <!-- Escritorio: autocomplete con dropdown -->
    <b-field v-else label="Nombre o código del producto">
      <b-autocomplete
        v-model="producto"
        id="producto"
        placeholder="Escribe el nombre o el código de barras del producto"
        :keep-first="true"
        :data="productosEncontrados"
        field="nombre"
        @input="buscarProductos"
        @select="seleccionarProducto"
      >
        <template slot-scope="props">
          <div>
            <span>{{ props.option.nombre }}</span>
            <span v-if="props.option.precioVenta !== undefined" class="has-text-grey is-size-7">
              &mdash; Precio: ${{ formatoMonto(props.option.precioVenta) }}
            </span>
          </div>
        </template>
      </b-autocomplete>
    </b-field>

    <div class="notification is-info mt-2" v-if="productoSeleccionado">
      <button class="delete" @click="deseleccionarProducto"></button>
      <p>Producto: <b>{{ productoSeleccionado.nombre }}</b></p>
      <p v-if="productoSeleccionado.codigo">Código: <b>{{ productoSeleccionado.codigo }}</b></p>
    </div>
  </section>
</template>
<script>
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'

const LIMITE_RESULTADOS = 20
const DEBOUNCE_MS = 300

export default {
  name: "BusquedaDeProducto",
  props: {
    initialProducto: {
      type: Object,
      default: () => null
    }
  },
  data: () => ({
    producto: "",
    productosEncontrados: [],
    productoSeleccionado: null,
    esMovil: false,
    mediaQuery: null,
    timerBusqueda: null,
    buscando: false
  }),
  mounted() {
    const mq = window.matchMedia('(max-width: 767px)')
    this.esMovil = mq.matches
    this.mediaQuery = mq
    if (mq.addEventListener) {
      mq.addEventListener('change', this.onCambioPantalla)
    } else if (mq.addListener) {
      mq.addListener(this.onCambioPantalla)
    }
  },
  beforeDestroy() {
    if (this.timerBusqueda) clearTimeout(this.timerBusqueda)

    if (this.mediaQuery) {
      if (this.mediaQuery.removeEventListener) {
        this.mediaQuery.removeEventListener('change', this.onCambioPantalla)
      } else if (this.mediaQuery.removeListener) {
        this.mediaQuery.removeListener(this.onCambioPantalla)
      }
    }
  },
  methods: {
    formatoMonto(valor) {
      return Utiles.formatoMonto(valor)
    },
    onCambioPantalla(evento) {
      this.esMovil = evento.matches
    },
    deseleccionarProducto() {
      this.productoSeleccionado = null
      this.$emit('deseleccionado')
    },
    seleccionarProducto(opcion) {
      if (!opcion) return
      this.productoSeleccionado = opcion
      this.$emit("seleccionado", this.productoSeleccionado)
      this.productosEncontrados = []
      setTimeout(() => this.producto = '', 10)
    },
    buscarProductos() {
      if (this.timerBusqueda) clearTimeout(this.timerBusqueda)

      if (!this.producto || !this.producto.trim()) {
        this.productosEncontrados = []
        this.buscando = false
        return
      }

      this.timerBusqueda = setTimeout(() => this.ejecutarBusqueda(), DEBOUNCE_MS)
    },
    ejecutarBusqueda() {
      const termino = this.producto.trim()
      if (!termino) return

      this.buscando = true
      let payload = {
        accion: 'obtener_nombre_codigo',
        producto: termino
      }
      HttpService.obtenerConConsultas('productos.php', payload)
        .then(productos => {
          this.productosEncontrados = (Array.isArray(productos) ? productos : []).slice(0, LIMITE_RESULTADOS)
          this.buscando = false
        })
        .catch(() => { this.buscando = false })
    },
  },
  watch: {
    initialProducto: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.nombre) {
          this.productoSeleccionado = newVal;
          this.producto = newVal.nombre;
        }
      }
    }
  }
}
</script>

<style scoped>
  .busqueda-de-producto {
    width: 100%;
    min-width: 0;
  }

  .busqueda-de-producto .field {
    width: 100%;
  }

  .lista-resultados-movil {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #dbdbdb;
    border-radius: 8px;
    background: #fff;
    max-height: min(55vh, 28rem);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .fila-producto {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 56px;
    box-sizing: border-box;
    gap: 12px;
    padding: 14px 16px;
    border: none;
    border-bottom: 1px solid #f5f5f5;
    background: transparent;
    text-align: left;
    cursor: pointer;
    font-family: inherit;
  }

  .fila-producto:last-child { border-bottom: none; }

  .fila-producto:active,
  .fila-producto:focus {
    background: #dbe4fd;
    outline: none;
  }

  .fila-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
    margin-right: 8px;
  }

  .fila-nombre {
    font-size: 16px;
    font-weight: 600;
    color: #363636;
    overflow-wrap: anywhere;
    line-height: 1.25;
  }

  .fila-detalle {
    font-size: 13px;
    color: #7a7a7a;
    margin-top: 3px;
    line-height: 1.3;
  }

  .fila-precio {
    display: flex;
    align-items: center;
    gap: 2px;
    flex: 0 0 auto;
    font-size: 15px;
    font-weight: 600;
    color: #3e8ed0;
    white-space: nowrap;
  }

  @media (max-width: 380px) {
    .fila-producto {
      gap: 8px;
      padding: 12px 10px;
    }

    .fila-detalle {
      font-size: 12px;
    }

    .fila-precio {
      font-size: 14px;
    }
  }
</style>